export default __webpack_public_path__ + "static/media/9.068177d0.gif";